import { get } from 'lodash';

const VIEWER_VERSION = '3.0';

interface CommonMetricData {
  example: boolean;
  job_id: number;
  org_id: number;
  org_name: string;
  partner_id: number;
  partner_name: string;
  shared: boolean;
  user_email: string;
  user_id: number;
  user_is_test_data: boolean;
  viewer_version: string;
  page_or_screen_name: string;
}

/**
 * Returns an object with all data that should be fired with every
 * analytics event
 * @param user User from API
 * @param job Job from API
 * @returns All the data
 */
const generateCommonMetricData = (user: any, job: any): CommonMetricData => ({
  example: job.example,
  job_id: job.id,
  org_id: get(user, 'orgs[0].id'),
  org_name: get(user, 'orgs[0].name'),
  partner_id: get(user, 'orgs[0].plan.partner.id'),
  partner_name: get(user, 'orgs[0].plan.partner.name'),
  shared: job.shared,
  user_email: user && user.email,
  user_id: user && user.id,
  user_is_test_data: user && user.test_data,
  viewer_version: VIEWER_VERSION,
  page_or_screen_name: 'Design-pro',
});

/**
 * Returns a timestamp object to override analytics provider's internal
 * time ordering with our own custom property. See the following documentation:
 * https://hoverinc.atlassian.net/wiki/spaces/EN/pages/928384174/Setting+up+the+Segment+SDK+in+your+app#Timestamps
 * @returns {Object} timestamp object
 */
const generateTimestamp = () => ({
  timestamp: new Date().toISOString(),
});

/**
 *
 * @param eventName Name of the metric event to fire
 * @param data Object with keys of extra data to add to the common metric
 * data sent with every event
 */
const trackMetric = (eventName: string, data: any) => {
  (window as any).analytics.track(eventName, data, generateTimestamp());
};

export default {
  generateCommonMetricData,
  generateTimestamp,
  trackMetric,
};
